import React from "react"
import classnames from "classnames"

const TopVenuesSelector = ({ venueGroups, selectedGroup, handleSelection }) => {
  const groups = Object.keys(venueGroups).map(group => ({
    slug: group,
    name: venueGroups[group].name
  }))

  return (
    <ul className="nav nav-justified nav-tabs nav-tabs--custom nav-tabs--primary">
      { groups.map((group, index) => (
        <li key={index} className={classnames(group.slug == selectedGroup && "active")}>
          <a href={`#${group.slug}`} onClick={handleSelection(group.slug)}>
            {group.name}
          </a>
        </li>
      )) }
    </ul>
  )
}

export default TopVenuesSelector



// WEBPACK FOOTER //
// ./components/top_venues/TopVenuesSelector.jsx